import { render, staticRenderFns } from "./ConversationView.vue?vue&type=template&id=a91b6bb4&scoped=true&"
import script from "./ConversationView.vue?vue&type=script&lang=ts&"
export * from "./ConversationView.vue?vue&type=script&lang=ts&"
import style0 from "./ConversationView.vue?vue&type=style&index=0&id=a91b6bb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a91b6bb4",
  null
  
)

export default component.exports